// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2fhne","location":"Header_location__1LXJZ"};